import { DataBean } from "../DataBean";

export class ConciliationReport extends DataBean {


    public async getBankingConciliationReport(idBankingConciliation:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getBankingConciliationReport_Number", [idBankingConciliation]);
    }

}